import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { Currency, CustomerVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<CustomerVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/DomainData/CurrencyMapping${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<CustomerVariables, null>({
  schema,
  dataPath: 'user:customer:currencies',
  verb: requestVerbs.GET,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  CustomerVariables,
  null,
  Currency,
  Currency[],
  Currency[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: currencies => currencies.id,
  processorFn: response => response,
});
